// S02: backend rejected the token (bad signature / expired) -> clear the session and go to login.
// Only the auth middleware sends msg.name; gatekeeper 403s ("no permission") are left alone.
const TOKEN_ERRORS = ['JsonWebTokenError', 'TokenExpiredError']
const SESSION_KEYS = ['__token__', '__perfil__', '__AuUser__', '__user_selected_id__', 'microAbreuUser', 'unicardUser']
let redirecting = false

export default function handleInvalidToken(status, body) {
    const name = body && body.msg && body.msg.name
    if (status !== 403 || !TOKEN_ERRORS.includes(name) || redirecting) return false
    redirecting = true
    // same keys as performlogout, but no server call: the token is already dead
    SESSION_KEYS.forEach(k => localStorage.removeItem(k))
    window.location.replace('/')
    return true
}
